/**
 * Static category/topic structure for the onboarding "Get Started" checklist
 *
 * Item ids for `transportation-management-system`, `saved-searches`, and `instant-book`
 * are shared with the existing entries of the same id in `constants/featureAnnouncements.js`
 * — those three walkthroughs are reused as-is, not re-authored, for this checklist.
 *
 * @typedef {Object} GetStartedCategory
 * @property {string} id  Stable, author-assigned slug.
 * @property {string} title  Display name.
 * @property {string[]} itemIds  The checklist items in this category, in display order.
 */

/** @type {GetStartedCategory[]} */
export const getStartedCategories = [
  {
    id: 'manage-profile',
    title: 'Manage Profile',
    itemIds: ['transportation-management-system', 'managing-users', 'setting-up-your-fleet'],
  },
  {
    id: 'book-your-first-job',
    title: 'Book Your First Job',
    itemIds: ['saved-searches', 'instant-book', 'staging-a-job'],
  },
  {
    id: 'manage-jobs',
    title: 'Manage Jobs',
    itemIds: ['downloading-release-slips', 'updating-pickup-delivery-status', 'cancelling-a-job'],
  },
];
